import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  border-radius: 4px;
  width: 100%;
  position: relative;
  flex-direction: column;

  .jus-c {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .btn-icon {
      border-radius: 8px;
      border: 1px solid #d0d5dd;
      box-shadow: 0px 0.777778px 1.55556px rgba(16, 24, 40, 0.05);
      cursor: pointer;
      transition: 0.4s background, 0.4s box-shadow;
    
      svg {
        transition: 0.4s color;
      }
    
      &.borderless {
        border-width: 0px;
        box-shadow: unset;
      }
    
      &:hover {
        background-color: #f3f4f6;
    
        &.borderless {
          box-shadow: 0px 0.777778px 1.55556px rgba(16, 24, 40, 0.05);
        }
      }

      &.selected {
        box-shadow: 0px 0px 0px 4px rgba(61, 142, 219, 0.3);
      }
    
      &.disabled {
        cursor: not-allowed;
        box-shadow: unset;
    
        svg {
          color: #d2d6db;
        }
      }

      span {
        color: #667085;
        font-size: 14px;
        font-weight: 500;
        margin-left: 8px;
      }

      svg { 
        margin-top: -4px;
      }
    }
  }

  .ant-table-wrapper {
    width: 100%;
  }

  .ant-table-placeholder {
    display: none;
  }

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: var(--font-size-lg); line-height: 22px;
    font-weight: 600;
		font-family: SF UI Display;
    color: #595959;
    padding: 12px;
    border-bottom: 1px solid #CCCCCC;
    width: 100%;
  }
  
  .overview {
    width: 330px;
    border-right: 1px solid #CCCCCC;
  }

  .list {
    flex: 1;
    overflow: hidden;

    .body {
      padding: 15px;
    }
  }

  .body {
    position: relative;
    overflow: hidden;
    height: 100%;
  }
`;

export default Style;
